import { faBedPulse } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslate } from "../../context/TranslationContext";
import { useGetHomeCourseQuery } from "../../redux/Apis/Course";
import Button from "../button";
import CourseCard from "../cards/CourseCard";
import OwlCarousel from "../carousel";
import SkeletonCourseCard from "./SkeletonCourseCard";

const CourseSection = ({ showCourseSection }) => {
  const { t } = useTranslate("coursebanner");
  const lang = useSelector((state) => state.language.lang);
  const { data, isLoading, refetch } = useGetHomeCourseQuery(
    {
      lang,
      page: 1,
      rowsPerPage: 7,
    },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  const courses = data?.data || [];

  useEffect(() => {
    refetch();
  }, []);

  if (!showCourseSection) return null;

  return (
    <section className="top-categories">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-9 mx-auto text-center">
            <h1 className="gallery-title mb-3 text-uppercase text-white">
              {t("title")}
            </h1>
            <p className="mb-0 p-lg l-grey-text">{t("subtitle")}</p>
            <div className="text-center mt-4 mb-5">
              <Button text={t("explorebtn")} to="/classes" />
            </div>
          </div>
        </div>

        <div className="row mt-4 px-2">
          {isLoading ? (
            <SkeletonCourseCard length={7} />
          ) : (
            <div className="col-12 px-sm-0">
              {courses.length === 0 ? (
                <h6 className="text-center my-5">{t("noCourses")}</h6>
              ) : (
                <OwlCarousel
                  className="category-carousel"
                  options={{
                    margin: 10,
                    loop: false,
                    rewind: true,
                    nav: true,
                    dots: false,
                    lazyLoad: true,
                    autoplay: true,
                    autoplayTimeout: 5000,
                    autoplayHoverPause: true,
                    smartSpeed: 500,
                    navText: [
                      '<i class="fas fa-angle-left"></i>',
                      '<i class="fas fa-angle-right"></i>',
                    ],
                    responsive: {
                      0: {
                        items: 2,
                        stagePadding: 0,
                        autoplay: false,
                      },
                      576: {
                        items: 2,
                        stagePadding: 20,
                        autoplay: faBedPulse,
                      },
                      768: {
                        items: 3,
                        stagePadding: 0,
                        autoplay: true,
                      },
                      992: {
                        items: 4,
                        stagePadding: 0,
                        autoplay: true,
                      },
                      1200: {
                        items: 5,
                        stagePadding: 0,
                        autoplay: true,
                      },
                    },
                  }}
                >
                  {courses.map((item) => (
                    <div className="item" key={item._id}>
                      <CourseCard data={item} />
                    </div>
                  ))}
                </OwlCarousel>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CourseSection;
